import { render, staticRenderFns } from "./blockInvoicesHistory.vue?vue&type=template&id=38536215&scoped=true&"
import script from "./blockInvoicesHistory.vue?vue&type=script&lang=js&"
export * from "./blockInvoicesHistory.vue?vue&type=script&lang=js&"
import style0 from "./blockInvoicesHistory.vue?vue&type=style&index=0&id=38536215&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38536215",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38536215')) {
      api.createRecord('38536215', component.options)
    } else {
      api.reload('38536215', component.options)
    }
    module.hot.accept("./blockInvoicesHistory.vue?vue&type=template&id=38536215&scoped=true&", function () {
      api.rerender('38536215', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/blockInvoices/blockInvoicesHistory.vue"
export default component.exports